import React from "react";
import { Link } from "react-router-dom";

export default function ResourceArticleCard({ article }) {
  if (!article) return null;
  const { slug, title, excerpt, heroImage, category, author, publishedAt } = article;

  const date = publishedAt
    ? new Date(publishedAt).toLocaleDateString(undefined, {
        month: "short",
        day: "numeric",
        year: "numeric",
      })
    : null;

  return (
    <li className="twentytwentysix-content__listing-card">
      <Link
        to={`/twentytwentysix/resources/${slug}`}
        className="twentytwentysix-content__listing-card-inner"
        aria-label={`Read article: ${title}`}
      >
        {heroImage ? (
          <div className="twentytwentysix-content__listing-image-wrap">
            <div className="twentytwentysix-content__listing-image-media">
              <img src={heroImage} alt={title} className="twentytwentysix-content__listing-image" />
            </div>
          </div>
        ) : (
          <div className="twentytwentysix-content__listing-image-wrap" aria-hidden="true">
            <div className="twentytwentysix-content__listing-image-placeholder" />
          </div>
        )}
        <div className="twentytwentysix-content__listing-body">
          {category && (
            <span className="twentytwentysix-content__listing-detail-meta">{category}</span>
          )}
          <strong className="twentytwentysix-content__listing-name">{title}</strong>
          {(author || date) && (
            <span className="twentytwentysix-content__event-card-meta">
              {author && <span>{author}</span>}
              {author && date && " · "}
              {date && <span>{date}</span>}
            </span>
          )}
          {excerpt && (
            <p className="twentytwentysix-content__listing-desc">{excerpt}</p>
          )}
          <span className="twentytwentysix-content__link twentytwentysix-content__event-card-cta">
            Read more →
          </span>
        </div>
      </Link>
    </li>
  );
}

